const europeanCountries = [
  'FI',
  'SE',
  'NO',
  'IS',
  'DK',
  'FO',
  'EE',
  'LV',
  'LT',
  'BY',
  'RU',
  'UA',
  'PL',
  'CZ',
  'SK',
  'HU',
  'DE',
  'AT',
  'CH',
  'LI',
  'GB',
  'IE',
  'NL',
  'BE',
  'LU',
  'FR',
  'MC',
  'RO',
  'BG',
  'RS',
  'AL',
  'GR',
  'SI',
  'HR',
  'ME',
  'MT',
  'IT',
  'SM',
  'ES',
  'PT',
  'AD',
  'GI',
  'BA',
  'CY',
];

export default europeanCountries;
